import { ActionTypes } from '../constants/index';

export const getNotificationById = (payload: any) => ({
  type: ActionTypes.NOTIFICATION_EDIT_REQUEST,
  payload,
});
